/*
 * config: { ignoreError: true },
 * config: { returnRes: true },
 * */
import * as httpUtil from "@/utils/httpUtil";

const interfaces: Array<Record<string, any>> = [
  {
    method: "post",
    name: "supplierList",
    url: "/c/pc/deliver/drug/supplierList",
    desc: "查询供应商列表",
  },
  {
    method: "post",
    name: "banned",
    url: "/c/pc/goodsPromotionPlan/banned",
    desc: "屏蔽或解除屏蔽",
  },
  {
    method: "post",
    name: "deleteById",
    url: "/c/pc/goodsPromotionPlan/deleteById",
    desc: "根据id删除推广计划",
  },
  {
    method: "postExFile",
    name: "exportList",
    url: "/c/pc/goodsPromotionPlan/exportList",
    desc: "导出",
  },
  {
    method: "post",
    name: "findByGoodsId",
    url: "/c/pc/goodsPromotionPlan/findByGoodsId",
    desc: "根据商品id查询推广详情",
  },
  {
    method: "post",
    name: "findById",
    url: "/c/pc/goodsPromotionPlan/findById",
    desc: "根据id查询推广详情",
  },
  {
    method: "post",
    name: "pageList",
    url: "/c/pc/goodsPromotionPlan/pageList",
    desc: "分页查询",
  },
  {
    method: "post",
    name: "saveOrUpdate",
    url: "/c/pc/goodsPromotionPlan/saveOrUpdate",
    desc: "新建或编辑推广",
  },
  {
    method: "post",
    name: "sync",
    url: "/c/pc/goodsPromotionPlan/sync",
    desc: "同步平台推广计划到社区",
  },
];

function exportsRender(interfacesArr: Array<Record<string, any>>) {
  const resultExports: Record<string, any> = {};
  interfacesArr.map((item: Record<string, any>) => {
    resultExports[item.name] = (data: Record<string | number, any>) => {
      return (httpUtil as Record<string, any>)[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}

export default exportsRender(interfaces);
